import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SessionManager } from '../sessionManager';
import { API_BASE_URL } from '../../config/apiConfig';
import { performGlobalLogout } from '../../utils/logoutUtils';

const BASE_URL = API_BASE_URL;

const publicEndpoints = [
  'exchangeToken',
];

const rawBaseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { endpoint }) => {
    if (!publicEndpoints.includes(endpoint)) {
      const authHeaders = SessionManager.getAuthHeaders();
      Object.entries(authHeaders).forEach(([k, v]) => headers.set(k, v));
    }
    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    await performGlobalLogout(api.dispatch, {
      toastMessage: 'Session expired. Please sign in again.',
      toastType: 'error',
      skipSupabaseSignOut: false,
    });

    api.dispatch({ type: 'api/util/resetApiState' });
  }

  return result;
};

export const apiClient = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth as any,
  tagTypes: ['Portfolio', 'PortfolioSite', 'AdminSite', 'Entity', 'Connection', 'QA', 'Event', 'Task', 'TaskGroup', 'Theme', 'Contract'],
  endpoints: () => ({}),
});
